
export default {
  namespaced: true,
  state: {
    hasPendingBills: false,
    isReady: false,
    feature: null, // delete this later
    version: 1,
    noSubscription: true,
    yezzaTrial: {
      value: false,
      data: {}
    },
    yezzaSubscription: {
      value: false,
      data: {},
      limitations: {}
    },
    yBooksTrial: {
      value: false,
      data: {},
    },
    yBooksSubscription: {
      value: false,
      data: {},
      limitations: {}
    },
    landingPageTrial: {
      value: false,
      data: {},
    },
    landingPageSubscription: {
      value: false,
      data: {},
      limitations: {}
    },
    followUpSubscription: {
      value: false,
      data: {},
      gene: null
    },
    bundleSubscription: {
      value: false,
      data: {},
      gene: null
    },
    resellerSubscription: {
      value: false,
      data: {},
      gene: null
    },
    connectSubscription: {
      value: false,
      data: {},
      limitations: {}
    },
    donationSubscription: {
      value: false,
      data: {},
      limitations: {}
    },
    clinicTrial: {
      value: false,
      data: {},
    },
    clinicSubscription: {
      value: false,
      data: {},
      limitations: {}
    },
    reviewTrial: {
      value: false,
      data: {},
      limitations: {}
    },
    reviewSubscription: {
      value: false,
      data: {},
      limitations: {}
    },
    genesData: []
  },
  mutations: {
    startFetching(state) {
      state.isReady = false
    },
    update(state) {
      state.version += 1
    },
    setSubscriptions (state, subscriptions) {
      state.noSubscription = true
      state.yezzaTrial.value = false
      state.yezzaSubscription.value = false
      state.yBooksTrial.value = false
      state.yBooksSubscription.value = false
      state.landingPageTrial.value = false
      state.landingPageSubscription.value = false
      state.followUpSubscription.value = false
      state.bundleSubscription.value = false
      state.resellerSubscription.value = false
      state.connectSubscription.value = false
      state.donationSubscription.value = false
      state.clinicTrial.value = false
      state.clinicSubscription.value = false
      state.reviewTrial.value = false
      state.reviewSubscription.value = false
      subscriptions.forEach(s => {
        if (s.plan_group === 'YEZZA'  && s.contract.code.includes('_TRIAL')) {
          state.yezzaTrial.value = true
          state.yezzaTrial.data = s
          state.noSubscription = false
          if (s.contract.code.includes('YZ_PERSONAL')) {
            state.feature = 'personal'
          } else if (s.contract.code.includes('YZ_BIZ')) {
            state.feature = 'business'
          } else if (s.contract.code.includes('YZ_INTEL')) {
            state.feature = 'intelligence'
          } else if (s.contract.code.includes('YZ_START_PLAN')) {
            state.feature = 'intelligence'
          } else if (s.contract.code.includes('YZ_GROWTH_PLAN')) {
            state.feature = 'intelligence'
          }
        }
        else if (s.plan_group === 'YEZZA' && !s.contract.code.includes('_TRIAL')) {
          state.yezzaSubscription.value = true
          state.yezzaSubscription.data = s
          state.noSubscription = false
          if (s.contract.code.includes('YZ_PERSONAL')) {
            state.feature = 'personal'
          } else if (s.contract.code.includes('YZ_BIZ')) {
            state.feature = 'business'
          } else if (s.contract.code.includes('YZ_INTEL')) {
            state.feature = 'intelligence'
          } else if (s.contract.code.includes('YZ_FREE_PLAN')) {
            state.feature = 'personal'
          } else if (s.contract.code.includes('YZ_FREE_V2_PLAN')) {
            state.feature = 'personal'
          } else if (s.contract.code.includes('YZ_START_PLAN')) {
            state.feature = 'intelligence'
          } else if (s.contract.code.includes('YZ_GROWTH_PLAN')) {
            state.feature = 'intelligence'
          }
        }
        else if (s.contract.code.includes('YBOOKS_') && s.contract.code.includes('_TRIAL')) {
          state.yBooksTrial.value = true
          state.yBooksTrial.data = s
          state.noSubscription = false
        }
        else if (s.contract.code.includes('YBOOKS_') && !s.contract.code.includes('_TRIAL')) {
          state.yBooksSubscription.value = true
          state.yBooksSubscription.data = s
          if (!s.expired) {
            state.noSubscription = false
          }
        }
        else if (s.plan_group === 'LANDING_PAGE' && s.contract.code.includes('_TRIAL')) {
          state.landingPageTrial.value = true
          state.landingPageTrial.data = s
          state.noSubscription = false
        }
        else if (s.plan_group === 'LANDING_PAGE' && !s.contract.code.includes('_TRIAL')) {
          state.landingPageSubscription.value = true
          state.landingPageSubscription.data = s
          if (!s.expired) {
            state.noSubscription = false
          }
        }
        else if (s.plan_group === 'FOLLOW_UP') {
          if (!s.expired) {
            state.followUpSubscription.value = true
            state.followUpSubscription.data = s
          }
        }
        else if (s.plan_group === 'PRODUCT_BUNDLE') {
          if (!s.expired) {
            state.bundleSubscription.value = true
            state.bundleSubscription.data = s
          }
        }
        else if (s.plan_group === 'RESELLER') {
          if (!s.expired) {
            state.resellerSubscription.value = true
            state.resellerSubscription.data = s
          }
        }
        else if (s.plan_group === 'YCONNECT') {
          if (!s.expired) {
            state.connectSubscription.value = true
            state.connectSubscription.data = s
            state.noSubscription = false
          }
        }
        else if (s.plan_group === 'YDONATION') {
          if (!s.expired) {
            state.donationSubscription.value = true
            state.donationSubscription.data = s
          }
        }
        else if (s.plan_group === 'YCLINIC' && s.contract.code.includes('_TRIAL')) {
          state.clinicTrial.value = true
          state.clinicTrial.data = s
          state.noSubscription = false
        }
        else if (s.plan_group === 'YCLINIC' && !s.contract.code.includes('_TRIAL')) {
          state.clinicSubscription.value = true
          state.clinicSubscription.data = s
          if (!s.expired) {
            state.noSubscription = false
          }
        }
        else if (s.plan_group === 'REVIEW' && s.contract.code.includes('_TRIAL')) {
          state.reviewTrial.value = true
          state.reviewTrial.data = s
          state.noSubscription = false
        }
        else if (s.plan_group === 'REVIEW' && !s.contract.code.includes('_TRIAL')) {
          if (!s.expired) {
            state.reviewSubscription.value = true
            state.reviewSubscription.data = s
            state.noSubscription = false
          }
        }
      })
      state.isReady = true
    },
    setHasPendingBills (state, hasPendingBills) {
      state.hasPendingBills = hasPendingBills
    },
    setDefaultFeature (state, company) {
      if (!state.feature) {
        state.feature = company.feature
      }
    },
    setLimitations (state, genes) {
      state.yezzaSubscription.limitations = {}
      state.yBooksSubscription.limitations = {}

      // member

      const member = (genes.find( g => g.feature === 'YZ_MEMBER') || { total: 0 }).total
      const freeMember = (genes.find( g => g.feature === 'YZ_FREE_MEMBER') || { total: 0 }).total
      state.yezzaSubscription.limitations.member = member + freeMember

      const unlimitedMember = (genes.find( g => g.feature === 'YZ_UNLIMITED_MEMBER') || { total: 0 }).total
      if (unlimitedMember >= 1) {
        state.yezzaSubscription.limitations.member = -1
      }


      // forms
      const form = (genes.find( g => g.feature === 'YZ_FORM') || { total: 0 }).total
      const freeForm = (genes.find( g => g.feature === 'YZ_FREE_FORM') || { total: 0 }).total
      state.yezzaSubscription.limitations.form = form + freeForm

      const unlimitedForm = (genes.find( g => g.feature === 'YZ_UNLIMITED_FORM') || { total: 0 }).total
      if (unlimitedForm >= 1) {
        state.yezzaSubscription.limitations.form = -1
      }

      // sales page
      state.yezzaSubscription.limitations.salespage = (genes.find( g => g.feature === 'YZ_LANDING_PAGE_FORM') || { total: 0 }).total

      // books reminder
      state.yBooksSubscription.limitations.reminder = (genes.find( g => g.feature === 'YBOOKS_REMINDER') || { total: 0 }).total

      // connect
      state.connectSubscription.limitations = {}
      state.connectSubscription.limitations.user = (genes.find(g => g.feature === 'YC_FREE_MEMBER') || { total: 0 }).total
      state.connectSubscription.limitations.segment = (genes.find(g => g.feature === 'YC_FREE_SEGMENT') || { total: 0 }).total

      const connectUnlimitedMember = (genes.find( g => g.feature === 'YC_UNLIMITED_MEMBER') || { total: 0 }).total
      if (connectUnlimitedMember >= 1) {
        state.connectSubscription.limitations.user = 5
      }
      const connectUnlimitedSegment = (genes.find( g => g.feature === 'YC_UNLIMITED_SEGMENT') || { total: 0 }).total
      if (connectUnlimitedSegment >= 1) {
        state.connectSubscription.limitations.segment = -1
      }
    },
    setGenes (state, genes) {
      state.genesData = []
      state.followUpSubscription.gene = null
      state.bundleSubscription.gene = null
      state.resellerSubscription.gene = null
      if (genes.find( g => g.feature === 'YZ_FOLLOW_UP')) {
        let gene = genes.find( g => g.feature === 'YZ_FOLLOW_UP')
        state.followUpSubscription.gene = {
          active: true,
          activeUntil: gene.active_until[0]
        }
      }
      if (genes.find( g => g.feature === 'YZ_PRODUCT_BUNDLE')) {
        let gene = genes.find( g => g.feature === 'YZ_PRODUCT_BUNDLE')
        state.bundleSubscription.gene = {
          active: true,
          activeUntil: gene.active_until[0]
        }
      }
      if (genes.find( g => g.feature === 'YZ_RESELLER')) {
        let gene = genes.find( g => g.feature === 'YZ_RESELLER')
        state.resellerSubscription.gene = {
          active: true,
          activeUntil: gene.active_until[0]
        }
      }
      
      genes.forEach(gene => {
        let geneData = {
          feature: gene.feature,
          total: gene.total,
          data: []
        }
        let uniqueDates = [...new Set(gene.active_until)]
        uniqueDates.forEach(o => {
          if (o) {
            let temp = {
              activeUntil: o,
              count: gene.active_until.filter(f => f === o).length
            }
            geneData.data.push(temp)
          }
        })
        state.genesData.push(geneData)
      })
    }
  }
}
